import type { LessonCreateStore } from './interfaces'

import { createLessonCreateState } from './state'

export const actions = {
  setLoading (this: LessonCreateStore, payload: LessonCreateStore['loading']): void {
    this.loading = payload
  },
  setSlots (this: LessonCreateStore, payload: LessonCreateStore['slots']): void {
    this.slots = payload
  },
  setType (this: LessonCreateStore, payload: LessonCreateStore['type']): void {
    this.type = payload
  },
  setToday (this: LessonCreateStore, payload: LessonCreateStore['today']): void {
    this.today = payload
  },
  setDate (this: LessonCreateStore, payload: LessonCreateStore['date']): void {
    this.date = payload
  },
  setStartTime (this: LessonCreateStore, payload: LessonCreateStore['startTime']): void {
    this.startTime = payload
  },
  setDuration (this: LessonCreateStore, payload: LessonCreateStore['duration']): void {
    this.duration = payload
  },
  setTutorId (this: LessonCreateStore, payload: LessonCreateStore['tutorId']): void {
    this.tutorId = payload
  },
  setAppliedFilters (this: LessonCreateStore, payload: LessonCreateStore['appliedFilters']): void {
    this.appliedFilters = payload
  },
  setTutorModalOpen (this: LessonCreateStore, payload: LessonCreateStore['tutorModalOpen']): void {
    this.tutorModalOpen = payload
  },
  setSaving (this: LessonCreateStore, payload: LessonCreateStore['saving']): void {
    this.saving = payload
  },
  reset (this: LessonCreateStore): void {
    Object.assign(this, createLessonCreateState())
  },
}
